import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

export const directions = [
  { dir: 'Up', icon: KeyboardArrowUp },
  { dir: 'Left', icon: KeyboardArrowLeft },
  { dir: 'Right', icon: KeyboardArrowRight },
  { dir: 'Down', icon: KeyboardArrowDown },
];
